<template>
  <div class="tile-stats white-bg">
    <div class="col-sm-12">
      <div class="status">
        <div class="portlet-heading">
          <h4 class="portlet-title text-dark text-uppercase">
            API
          </h4>
          <div class="portlet-widgets">
            <a href="#" data-toggle="reload"><i class="ion-refresh"></i></a>
            <span class="divider"></span>
            <a data-toggle="collapse" data-parent="#accordion1" href="#portlet2"><i class="ion-minus-round"></i></a>
            <span class="divider"></span>
            <a href="#" data-toggle="remove"><i class="ion-close-round"></i></a>
          </div>
          <div class="clearfix"></div>
        </div>

        <div class="form-group" v-if="customerId">
          <p>Your Account Number</p>
          <div class="input-group">
            <input type="text" id="input-account" class="form-control" :value="customerId" readonly="">
          </div>
        </div>

        <div class="form-group">
          <p>Your private API key</p>
          <div class="input-group">

            <input class="form-control" readonly="" :type="tokenType" :value="token">
            <span class="input-group-btn">
              <button class="btn btn-default" type="button" @click="toggleTokenVisibility"><i class="fa fa-eye"></i></button>
              <button class="btn btn-default" type="button" @click="refreshToken"><i class="fa fa-refresh"></i></button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['dataToken', 'dataCustomerId'],
  data () {
    return {
      token: this.dataToken,
      customerId: this.dataCustomerId,
      tokenVisible: false,
      refreshingToken: false
    }
  },
  computed: {
    csrf_token () {
      return document.querySelector("meta[name='csrf-token']")
        .getAttribute('content')
    },
    tokenType () {
      if (this.tokenVisible) {
        return 'text'
      } else {
        return 'password'
      }
    }
  },
  methods: {
    refreshToken () {
      this.refreshingToken = true
      axios.post('/refresh_token', {}, {
        headers: { 'X-CSRF-Token': this.csrf_token }
      })
      .then(response => {
        this.token = response.data.api_token
        this.refreshingToken = false
      })
      .catch(e => {
        console.log(e.response.data)
        this.refreshingToken = false
      })
    },
    toggleTokenVisibility () {
      this.tokenVisible = !this.tokenVisible
    }
  }
}
</script>



// WEBPACK FOOTER //
// app/javascript/components/dashboard/api-key.vue?60d5c9c1